import React from "react";

import useFirebaseKilns from "../hooks/useFirebaseKilns";
import { Card, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Link } from "react-router";
import { Plus } from "lucide-react";

import KilnCard from "./KilnCard";
import PageHeader from "./PageHeader";

const KilnsListPage = ({ navigation }: { navigation?: any }) => {
  const kilns = useFirebaseKilns();

  if (kilns === undefined) {
    return (
      <div className="space-y-6">
        <PageHeader title="Kilns" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <Card key={i} className="overflow-hidden">
              <CardHeader><div className="h-5 w-3/4 bg-muted animate-pulse rounded" /></CardHeader>
              <div className="px-6 pb-6"><div className="h-16 bg-muted animate-pulse rounded" /></div>
            </Card>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <PageHeader
        title="Kilns"
        actions={
          <Link to="/new_kiln">
            <Button><Plus className="h-4 w-4 mr-1" />Add New Kiln</Button>
          </Link>
        }
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {kilns && Object.values(kilns).map((kiln) => kiln && <KilnCard {...kiln} key={kiln.id} />)}
      </div>
    </div>
  );
};

export default KilnsListPage;
